import { Action } from "redux"
import { FlowControlDTO } from "../../apis/models/fields"

export const INITIALIZE = "RESOURCEFOOTER_INITIALIZE"
export const REQUEST_STATE_TRANSITION_BUTTONS =
    "RESOURCEFOOTER_REQUEST_STATE_TRANSITION_BUTTONS"
export const RECEIVE_STATE_TRANSITION_BUTTONS =
    "RESOURCEFOOTER_RECEIVE_STATE_TRANSITION_BUTTONS"
export const CLICK_STATE_TRANSITION_BUTTON =
    "RESOURCEFOOTER_CLICK_STATE_TRANSITION_BUTTON"

export interface Initialize extends Action {
    itemId: number
}

export const initialize = (itemId: number): Initialize => ({
    type: INITIALIZE,
    itemId,
})

export const requestStateTransitionButtons = (): Action => ({
    type: REQUEST_STATE_TRANSITION_BUTTONS,
})

export interface ReceiveStateTransitionButtons extends Action {
    buttons: FlowControlDTO[]
}

export const receiveStateTransitionButtons = (
    buttons: FlowControlDTO[],
): ReceiveStateTransitionButtons => ({
    type: RECEIVE_STATE_TRANSITION_BUTTONS,
    buttons,
})

export interface ClickStateTransitionButton extends Action {
    toItemStatusId: number
}

export const clickStateTransitionButton = (
    toItemStatusId: number,
): ClickStateTransitionButton => ({
    type: CLICK_STATE_TRANSITION_BUTTON,
    toItemStatusId,
})

export const mapDispatchToProps = {
    requestStateTransitionButtons,
    receiveStateTransitionButtons,
    clickStateTransitionButton,
}

export type DispatchProps = typeof mapDispatchToProps
